import cn from 'classnames'

import { Accordion } from '@components/Accordion'
import { SortEnum, SortTypeValue } from '@interfaces/SortEnum'
import { SwapVertIDownActiveIcon } from '@components/icons/SwapVertIDownActiveIcon'
import CoinButton from '@components/CoinButton'
import { Box } from '@features/story/components/Box'
import { ChapterManageProps } from './interface'
import { ChapterGroupItem } from '../ChapterGroupItem'
import { BuyChapterTab } from '../BuyChapterTab/BuyChapterTab'
import { CheckboxInput } from '@components/CheckboxInput/CheckboxInput'

export const ChapterManage = ({
  className,
  sorter,
  bookId,
  chapterGroups,
  totalChapter,
  totalPrice,
  bookName,
  bookCategory,
  showBuyAllChapterButton,
  isDrawer,
  isManga,
  isOwner,
  canAction,
  isBuyAllChapterFetching,
  bookType,
  bookReadPromotionDetail,
  handleSortData,
  handleBuyAllChapter,
  handleBuyChapters,
  toggleBuyChapters,
  selectedChapters,
  allSelectedAllPage,
  handleSelectChapter,
  handleSelectChapters,
  onAccordionChange,
  accordionRefs,
  noBuyableChapterPage,
}: ChapterManageProps) => {
  return (
    <Box className={cn('mobile:px-[20px] mobile:pb-0', className)}>
      <div
        className={cn(
          'flex flex-col small-desktop:flex-row desktop:items-center space-y-[20px] small-desktop:space-y-0 justify-between p-[20px] mobile:p-[10px] rounded-t-lg',
          {
            '!flex-col !space-y-[20px]': isDrawer,
          }
        )}
      >
        <div
          className={cn('flex justify-between small-desktop:justify-start', {
            '!justify-between': isDrawer,
          })}
        >
          <Box.Name className='text-2xl text-secondary dark:text-dark-10 mobile:flex mobile:flex-col'>
            <span> ตอนทั้งหมด : </span>
            <Box.Text className='dark:text-dark-10'>
              <span>{totalChapter.toLocaleString()} ตอน</span>
            </Box.Text>
          </Box.Name>
          <div
            className={cn(
              'flex flex-row items-center text-secondary dark:text-dark-10 cursor-pointer small-desktop:hidden',
              {
                '!flex': isDrawer,
              }
            )}
            onClick={handleSortData}
          >
            <span className='text-sm font-light mr-[5px] dark:text-dark-10'>
              {SortTypeValue[sorter]}
            </span>
            <SwapVertIDownActiveIcon
              className={cn({ 'rotate-180': sorter === SortEnum.DESC })}
            />
          </div>
        </div>
        <div
          className={cn(
            'flex flex-col small-desktop:flex-row gap-4 small-desktop:gap-[20px] items-center select-none mobile:w-full',
            {
              '!flex-col !gap-[20px]': isDrawer,
            }
          )}
        >
          <div
            className={cn(
              'flex-shrink-0 flex-row items-center text-secondary cursor-pointer hidden small-desktop:flex',
              {
                '!hidden': isDrawer,
              }
            )}
            onClick={handleSortData}
          >
            <span className='text-sm font-light mr-[5px] dark:text-dark-10'>
              {SortTypeValue[sorter]}
            </span>
            <SwapVertIDownActiveIcon
              className={cn({ 'rotate-180': sorter === SortEnum.DESC })}
            />
          </div>
          {showBuyAllChapterButton && (
            <CoinButton
              type='button'
              onClick={handleBuyAllChapter}
              className='w-full small-desktop:min-w-[310px]'
              secondClassName='text-xl h-[40px]'
              data-test='buy-all-chapter'
              size={40}
              disabled={isBuyAllChapterFetching}
            >
              {`ซื้อทุกตอน (${totalPrice.toLocaleString()} เหรียญ)`}
            </CoinButton>
          )}
          {showBuyAllChapterButton && (
            <CoinButton
              type='button'
              onClick={handleBuyChapters}
              className='w-full small-desktop:min-w-[200px]'
              secondClassName='text-xl h-[40px]'
              data-test='buy-chapters'
              size={40}
              disabled={isBuyAllChapterFetching}
            >
              ซื้อหลายตอน
            </CoinButton>
          )}
        </div>
      </div>

      {toggleBuyChapters && (
        <BuyChapterTab
          className={cn('sticky top-[70px] z-[1]', {
            'desktop-tablet:!w-[calc(100%-40px)] mx-auto': isDrawer,
          })}
          disabled={!selectedChapters.length}
          chapters={selectedChapters}
          handleCancel={handleBuyChapters}
          handleBuyChapter={handleBuyAllChapter}
        />
      )}

      <div>
        {chapterGroups
          .sort((a, b) =>
            sorter === SortEnum.ASC ? a.order - b.order : b.order - a.order
          )
          .map((row, index: number) => (
            <Accordion
              key={index}
              ref={el => {
                if (accordionRefs.current && el) {
                  accordionRefs.current[index] = el
                }
              }}
              initialActive={
                sorter === SortEnum.ASC
                  ? row.order === 0
                  : row.order === Math.floor(totalChapter / 50)
              }
              title={
                <>
                  {toggleBuyChapters ? (
                    <div
                      tabIndex={0}
                      onClick={e => {
                        !noBuyableChapterPage.includes(row.order + 1) &&
                          e.stopPropagation()
                      }}
                    >
                      <CheckboxInput
                        name={`chapter.group.${index}`}
                        disabled={noBuyableChapterPage.includes(row.order + 1)}
                        checked={allSelectedAllPage.includes(row.order + 1)}
                        onChange={e => {
                          onAccordionChange(
                            index,
                            row.order + 1,
                            (e.target as HTMLInputElement).checked
                          )
                        }}
                      >
                        <span className='text-secondary-1'>ตอนที่ </span>{' '}
                        {row.name}
                      </CheckboxInput>
                    </div>
                  ) : (
                    <label>
                      <span className='text-secondary-1'>ตอนที่ </span>{' '}
                      {row.name}
                    </label>
                  )}
                </>
              }
            >
              <ChapterGroupItem
                sorter={sorter}
                bookId={bookId}
                page={row.order + 1}
                totalChapter={totalChapter}
                bookName={bookName}
                bookType={bookType}
                bookCategory={bookCategory}
                bookReadPromotionDetail={bookReadPromotionDetail}
                isOwner={isOwner}
                isDrawer={isDrawer}
                isManga={isManga}
                isSelect={toggleBuyChapters}
                selectedChapters={selectedChapters}
                canAction={canAction}
                handleSelectChapter={handleSelectChapter}
                onLoad={d => handleSelectChapters(d, row.order + 1)}
              />
            </Accordion>
          ))}
      </div>
    </Box>
  )
}
